
import { mapGetters } from 'vuex'
import { Currency } from '~/plugins/Currency'
import Types from '@/static/database/Types.json'
import { convertToSlug } from '~/helpers/generate-slug'
export default {
  computed: {
    ...mapGetters({
      getPopularProducts: 'popularProducts/getPopularProducts',
      getUserIP: 'user/getUserIP',
    }),
  },
  data() {
    return {
      Types,
    }
  },
  methods: {
    convertToSlug,
    Currency(p) {
      return Currency(p, this.getUserIP.currency)
    },
    type(type) {
      return Types.find((t) => t.type === type)
    },
  },
}
